// extracted by mini-css-extract-plugin
export default {"container":"SolarisCalculator_container__MjU4F"};